import superagentMiddleware from "redux-superagent-middleware";

import consts from "consts/consts";

// Create an superagentMiddleware for superagentMiddleware
const superagent = superagentMiddleware({
  base: consts.config.apiBaseUrl,
  defaultHeaders: {
    Accept: "application/json",
    "Content-type": "application/x-www-form-urlencoded",
  },
  hooks: {
    onRequest: (store, action, request) => {
      request.headers["Content-type"] = "application/json";
      return request;
    },
    onFailure: (store, action, request) => {
      //if(request.name === "references") {
      //store.dispatch(action.onError())
      //}
      return false;
    },
    onError: (store, action, request, response) => {
      console.error("------------------ERROR", response);
      if (response.body && response.body.error && response.body.error.type === "access_denied") {
        store.dispatch(action);
        return false;
      }
      if (response.status === 409) {
        store.dispatch(action);
      }
    },
  },
});

export default superagent;



// WEBPACK FOOTER //
// ./src/middlewares/superagent.js